<script setup lang="ts">
import { eachYearOfInterval, endOfYear, isSameYear } from 'date-fns'
import { isCalendarIntervalDisabled } from '../calendarAvailability'
import { CellState } from '../index'
import CalendarDate from './CalendarDate.vue'

const props = withDefaults(
  defineProps<{
    today?: Date
    disabledDate?: (date: Date) => boolean
  }>(),
  {
    today: () => new Date(),
  },
)

const model = defineModel<Date>({ default: () => new Date() })

const years = computed(() =>
  eachYearOfInterval({
    start: new Date(model.value.getFullYear(), 0),
    end: new Date(model.value.getFullYear() + 11, 0),
  }).map(value => ({ value, label: value.getFullYear() })),
)

function getState(date: Date) {
  if (isCalendarIntervalDisabled({ start: date, end: endOfYear(date) }, props.disabledDate)) {
    return CellState.Disabled
  }
  return isSameYear(model.value, date) ? CellState.Selected : CellState.Default
}
</script>

<template lang="pug">
.display-grid.grid-cols-3.row-gap-12.column-gap-8.p-t-24
  .flex-center-center.h-56(v-for="year of years" :key="year.label")
    CalendarDate(
      :label="year.label"
      :state="getState(year.value)"
      :today="isSameYear(year.value, today)"
      @click="model = year.value"
    )
</template>
